<div *ngIf="isLoading" class="text-gray-500 italic">{{ 'COMMON.LOADING' | translate }}</div>

<div *ngIf="policyDetails && !isLoading">
  <!-- Policy Information Card -->
  <div class="card p-4 border rounded shadow-sm bg-white mb-4">
    <h3 class="text-lg font-semibold text-blue-600 mb-4 text-center">
      {{ 'DASHBOARD.POLICIES.POLICY_DETAILS.POLICY_INFORMATION' | translate }}
    </h3>
    <div class="grid grid-cols-2 gap-4">
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.POLICY_NUMBER' | translate }}:</strong> {{ policyDetails.policyNumber }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.STATUS' | translate }}:</strong> {{ policyDetails.status }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.PROVIDER_NAME' | translate }}:</strong> {{ policyDetails.providerName }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.CR_NUMBER' | translate }}:</strong> {{ policyDetails.crNumber }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.START_DATE' | translate }}:</strong> {{ formatDateArray(policyDetails.startDate) }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.END_DATE' | translate }}:</strong> {{ formatDateArray(policyDetails.endDate) }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.ISSUED_DATE' | translate }}:</strong> {{ formatDateArray(policyDetails.issuedDate) }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.TOTAL_PREMIUM' | translate }}:</strong> {{ policyDetails.totalPremium }} {{ policyDetails.currency }}
      </p>
    </div>
  </div>

  <!-- Quote Response Information Card -->
  <div class="card p-4 border rounded shadow-sm bg-white mb-4" *ngIf="policyDetails && policyDetails.quoteResponse">
    <h3 class="text-lg font-semibold text-blue-600 mb-4 text-center">
      {{ 'DASHBOARD.POLICIES.POLICY_DETAILS.QUOTE_INFORMATION' | translate }}
    </h3>
    <div class="grid grid-cols-2 gap-4">
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.QUOTE_REFERENCE_NO' | translate }}:</strong> {{ policyDetails.quoteResponse.quoteReferenceNo }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.RESPONSE_ID' | translate }}:</strong> {{ policyDetails.quoteResponse.responseId }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.QUOTE_STATUS' | translate }}:</strong> {{ policyDetails.quoteResponse.status }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.PROVIDER_NAME' | translate }}:</strong> {{ policyDetails.quoteResponse.providerName }}
      </p>
      <p *ngIf="policyDetails && policyDetails.quoteResponse && policyDetails.quoteResponse.entityNameAr">
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.ENTITY_NAME_AR' | translate }}:</strong> {{ policyDetails.quoteResponse.entityNameAr }}
      </p>
      <p *ngIf="policyDetails && policyDetails.quoteResponse && policyDetails.quoteResponse.entity700Number">
        <strong>Entity 700 Number:</strong> {{ policyDetails.quoteResponse.entity700Number }}
      </p>
      <p *ngIf="policyDetails && policyDetails.quoteResponse && policyDetails.quoteResponse.primaryCount">
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.PRIMARY_MEMBERS' | translate }}:</strong> {{ policyDetails.quoteResponse.primaryCount }}
      </p>
      <p *ngIf="policyDetails.quoteResponse.dependentCount">
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.DEPENDENTS' | translate }}:</strong> {{ policyDetails.quoteResponse.dependentCount }}
      </p>
      <p *ngIf="policyDetails.quoteResponse.insuranceCompanyCode">
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.INSURANCE_COMPANY_CODE' | translate }}:</strong> {{ policyDetails.quoteResponse.insuranceCompanyCode }}
      </p>
    </div>
  </div>

  <!-- Quote Request Information Card -->
  <div class="card p-4 border rounded shadow-sm bg-white mb-4" *ngIf="policyDetails && policyDetails.quoteResponse && policyDetails.quoteResponse.quoteRequest">
    <h3 class="text-lg font-semibold text-blue-600 mb-4 text-center">
      {{ 'DASHBOARD.POLICIES.POLICY_DETAILS.QUOTE_REQUEST_DETAILS' | translate }}
    </h3>
    <div class="grid grid-cols-2 gap-4">
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.REQUEST_ID' | translate }}:</strong> {{ policyDetails.quoteResponse.quoteRequest.id }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.COMPANY_ID' | translate }}:</strong> {{ policyDetails.quoteResponse.quoteRequest.companyId }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.ENTITY_NAME_AR' | translate }}:</strong> {{ policyDetails.quoteResponse.quoteRequest.entityNameAr }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.ENTITY_TYPE' | translate }}:</strong> {{ policyDetails.quoteResponse.quoteRequest.entityType }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.INSURANCE_COMPANY_CODE' | translate }}:</strong> {{ policyDetails.quoteResponse.quoteRequest.insuranceCompanyCode }}
      </p>
      <p>
        <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.INSURANCE_TYPE_ID' | translate }}:</strong> {{ policyDetails.quoteResponse.quoteRequest.insuranceTypeId }}
      </p>
    </div>
  </div>

  <!-- Members Information Card -->
  <div class="card p-4 border rounded shadow-sm bg-white mb-4" *ngIf="policyDetails && policyDetails.members && policyDetails.members.length > 0">
    <h3 class="text-lg font-semibold text-blue-600 mb-4 text-center">
      {{ 'DASHBOARD.POLICIES.POLICY_DETAILS.POLICY_MEMBERS' | translate }} ({{ policyDetails.members.length }})
    </h3>
    <div class="space-y-3">
      <div 
        *ngFor="let member of policyDetails.members; let i = index" 
        class="p-3 border border-gray-200 rounded-lg bg-gray-50"
      >
        <div class="grid grid-cols-2 gap-4">
          <p>
            <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.MEMBER_NAME' | translate }} {{ i + 1 }}:</strong> {{ member.name }}
          </p>
          <p>
            <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.MEMBER_TYPE' | translate }}:</strong> {{ member.memberType }}
          </p>
          <p>
            <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.ID_NUMBER' | translate }}:</strong> {{ member.idNumber }}
          </p>
          <p>
            <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.DATE_OF_BIRTH' | translate }}:</strong> {{ formatDateArray(member.dob) }}
          </p>
          <p *ngIf="member.premiumAmount">
            <strong>{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.PREMIUM_AMOUNT' | translate }}:</strong> {{ member.premiumAmount }} {{ policyDetails.currency }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isLoading && !policyDetails">
  <h4 class="text-lg font-semibold mb-4">{{ 'DASHBOARD.POLICIES.POLICY_DETAILS.TITLE' | translate }}</h4>

  <div
    class="bg-red-100 border border-red-400 text-red-700 px-8 py-3 rounded mb-4"
  >
    {{ 'DASHBOARD.POLICIES.POLICY_DETAILS.NO_DETAILS_AVAILABLE' | translate }}
  </div>
</div>

<div>
  <button
    (click)="goBack()"
    class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
  >
    {{ 'DASHBOARD.POLICIES.POLICY_DETAILS.BACK' | translate }}
  </button>
</div>
